import { render, staticRenderFns } from "./ProjectActions.vue?vue&type=template&id=0baad4fc&scoped=true&lang=pug&"
import script from "./ProjectActions.vue?vue&type=script&lang=js&"
export * from "./ProjectActions.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActions.vue?vue&type=style&index=0&id=0baad4fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baad4fc",
  null
  
)

export default component.exports